import React, { useContext, useState } from "react";
import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../shared/CiroButton";
import { EnumPersonaSource } from "../../../../__generated__/graphql";
import AutopilotCuratedSearchContext from "../../../../contexts/AutopilotCuratedSearchContext";

interface ISuggestedPersonaPills {
  onSelectPersona: (description: string) => void;
}

const SuggestedPersonaPills = ({ onSelectPersona }: ISuggestedPersonaPills) => {
  const { personas } = useContext(AutopilotCuratedSearchContext);

  const [expanded, setExpanded] = useState(false);
  const INITIAL_DISPLAY_COUNT = 6;

  // Filter to short, suggested personas (exclude detailed ones)
  const suggestedPersonas = personas.filter(
    (persona) =>
      // Only include personas with short descriptions (likely the auto-generated ones)
      persona.description.length < 100 &&
      persona.source === EnumPersonaSource.Ciro,
  );

  if (suggestedPersonas.length === 0) {
    return null;
  }

  // Show all if expanded, otherwise show just the first 6
  const visiblePersonas = expanded
    ? suggestedPersonas
    : suggestedPersonas.slice(0, INITIAL_DISPLAY_COUNT);

  // Only show toggle button if there are more than the initial count
  const showToggle = suggestedPersonas.length > INITIAL_DISPLAY_COUNT;

  return (
    <div className="my-1">
      <div className={classNames("flex", "flex-wrap", "gap-2", "items-center")}>
        {visiblePersonas.map((persona) => (
          <CiroButton
            key={persona.id}
            onClick={() => onSelectPersona(persona.description)}
            style={CiroButtonStyleEnum.UNSTYLED}
            customClassName={classNames(
              "rounded-full",
              "px-3",
              "py-1",
              "text-xs",
              "transition-colors",
              "border",
              "border-gray-200",
              "text-gray-700",
              "hover:bg-gray-100",
              "focus:outline-none",
              "focus:ring-2",
              "focus:ring-orange-500",
              "focus:ring-opacity-50",
            )}
            analyticsField={"Selected persona from pill"}
            analyticsProps={{
              persona: persona.name,
            }}
          >
            {persona.description}
          </CiroButton>
        ))}

        {showToggle && (
          <CiroButton
            style={CiroButtonStyleEnum.UNSTYLED}
            customClassName={classNames(
              "text-sm",
              "text-orange-600",
              "hover:text-orange-700",
              "font-medium",
              "ml-1",
            )}
            analyticsField="suggested_personas_toggle"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "View less" : "View more"}
          </CiroButton>
        )}
      </div>
    </div>
  );
};

export default SuggestedPersonaPills;
